export const MainServicesArray = [
  {
    label: 'Online Sessions',
    description: 'Exclusive online domination and control sessions tailored to your desires.',
  },
  {
    label: 'Real-Time Domination',
    description: 'In-person sessions for those worthy of serving Mistress Sammi in real life.',
  },
  {
    label: 'Fansites & Content',
    description: 'Access to exclusive content, clips, and private fan interactions.',
  },
  {
    label: 'Keyholding & Chastity',
    description: 'Long-term control and keyholding services for true devotion.',
  },
  {
    label: 'Custom Fetish Requests',
    description: 'Bespoke experiences tailored to your deepest fantasies.',
  },
  {
    label: 'Findom & Financial Domination',
    description: 'Financial servitude for submissives who crave true ownership.',
  },
  {
    label: 'Adult Baby & Sissification',
    description: 'ABDL and sissy training for those who need to be properly disciplined.',
  },
];
